// extracted by mini-css-extract-plugin
export default {"home":"Home_home__6bQvM","subheading":"Home_subheading__nw0G4","quote":"Home_quote__WWdhC","carousel-root":"Home_carousel-root__evQX0"};